module.exports = "https://coursera_assets.s3.amazonaws.com/images/040c42e04790ced39bc1b8f4c3341c3f.png";